import { render, staticRenderFns } from "./TabelaResultadosCargoColegiado.vue?vue&type=template&id=397e5efa&scoped=true&"
import script from "./TabelaResultadosCargoColegiado.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosCargoColegiado.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosCargoColegiado.vue?vue&type=style&index=0&id=397e5efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e5efa",
  null
  
)

export default component.exports